import { Button, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useCallback, useState } from 'react';

import IconDigitalItem from '../../../assets/images/icon-digital-item.svg';
import IconMskuItem from '../../../assets/images/icon-msku-item.svg';
import IconPhysicalItem from '../../../assets/images/icon-physical-item.svg';
import IconUploadItemsCsv from '../../../assets/images/icon-upload-items-csv.svg';
import { InventoryTypesEnum } from '../../../types/inventories';

interface IProps {
  onAddNewItem: (type: InventoryTypesEnum) => void;
  onCsvUpload: () => void;
  dataAction?: string;
}

export const AddItemButton: React.FC<IProps> = ({ onAddNewItem, onCsvUpload, dataAction }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const handleMenuItemClick = useCallback(
    (itemType: InventoryTypesEnum) => {
      onAddNewItem(itemType);
      handleClose();
    },
    [onAddNewItem, handleClose],
  );

  const handleCsvUpload = useCallback(() => {
    onCsvUpload();
    handleClose();
  }, [onCsvUpload, handleClose]);

  return (
    <>
      <Button variant="contained" sx={{ width: 121, marginLeft: 2 }} onClick={handleClick} data-action={dataAction}>
        Add new item
      </Button>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose} sx={{ marginTop: 0.5, marginRight: 1 }}>
        <MenuItem onClick={() => handleMenuItemClick(InventoryTypesEnum.Physical)}>
          <ListItemIcon>
            <img src={IconPhysicalItem} alt="Physical Item" width="20" height="20" />
          </ListItemIcon>
          <ListItemText primary="Add physical" />
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick(InventoryTypesEnum.Digital)}>
          <ListItemIcon>
            <img src={IconDigitalItem} alt="Digital Item" width="20" height="20" />
          </ListItemIcon>
          <ListItemText primary="Add digital" />
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick(InventoryTypesEnum.MSKU)}>
          <ListItemIcon>
            <img src={IconMskuItem} alt="MSKU Item" width="20" height="20" />
          </ListItemIcon>
          <ListItemText primary="Add MSKU" />
        </MenuItem>
        <Divider sx={{ marginY: 0 }} />
        <MenuItem onClick={handleCsvUpload}>
          <ListItemIcon>
            <img src={IconUploadItemsCsv} alt="Upload Items CSV" width="20" height="20" />
          </ListItemIcon>
          <ListItemText primary="Add via CSV" />
        </MenuItem>
      </Menu>
    </>
  );
};
